<template>
  <div 
    :class="baseRadioClasses" 
    class="base-radio"
  >
    <div 
      class="base-radio__container" 
      @click.stop="toggleRadio"
    >
      <input
        :id="id || uniqueId"
        :name="name"
        :value="value"
        :disabled="isDisabled"
        :checked="isSelected"
        type="radio"
      >
    </div>

    <label
      v-if="$slots.default"
      :for="id || uniqueId"
      class="base-radio__label"
    >
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  model: {
    prop: "model",
    event: "change",
  },
};
</script>

<script setup>
import { ref, computed, onMounted } from "vue";

const props = defineProps({
  id: {
    type: String,
    default: undefined,
  },
  model: {
    type: [String, Array, Boolean],
    default: undefined,
  },
  value: {
    type: String,
    default: undefined,
  },
  name: {
    type: [String, Number],
    default: "",
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["change"]);

const uniqueId = ref("");

const isSelected = computed(() => props.model === props.value);

const baseRadioClasses = computed(() => ({
  "base-radio--is-selected": isSelected.value,
  "base-radio--is-disabled": props.isDisabled,
}));

const toggleRadio = () => {
  if (!props.isDisabled) {
    emit("change", props.value);
  }
};

const getUniqueId = () => {
  if (props.id === undefined || typeof props.id !== 'string') {
    uniqueId.value = `base-radio--${Math.random()
      .toString(36)
      .substring(2, 10)}`;
  } else {
    uniqueId.value = props.id;
  }
};

onMounted(() => {
  getUniqueId();
});
</script>

<style lang="scss">
@import "./base-radio.scss";
</style>
